import { cartHasPrime } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const PrimeSavings = (props) => {
  const { order, settings } = props;
  if (!cartHasPrime(order)) {
    return null;
  }
  if (!order.shipping || order.shipping.length === 0) {
    return null;
  }
  if (order.shipping[0].price === 0 && order.shipping[0].originalPrice !== 0) {
    return (
      <div className="c7-order-summary__promotion-message">
        <div>
          <em>Saved with ⭑ Star Shipping:</em>
        </div>
        <div>{currencyFormat(order.shipping[0].originalPrice, settings)}</div>
      </div>
    );
  }
  return null;
};

export default PrimeSavings;
